import React from 'react';
import FooterComponent from './FooterComponent';
import OrdersContentComponent from './OrdersContentComponent';

class OrdersComponent extends React.Component {
    render() {
        return(
            <div className="main-panel">
                <OrdersContentComponent location={this.props.location}/>
                <FooterComponent/>
            </div>
        );
    }
}

export default OrdersComponent;